module.exports = __webpack_public_path__ + "static/media/notebook-gray.f4e94a2b.svg";